import moment from 'moment'

const mapCommonFilters = {
	formatdate: function (value) {
		var m = moment(String(value))
		var diffDays = m.diff(moment(), 'days')
		if (diffDays == 0) return moment(String(value)).format('hh:mm a')
		else return moment(String(value)).format('MMM D')
	},
	bodyPreview: function (value) {
		value = value.replace(/<\/?[^>]+(>|$)/g, " ").trim().replace(/\s\s+/g, ' ');
		if (value && value != "") {
			var words = value.split(" ");
			var preview = "";
			for (var i=0; i<=10; i++) {
			  if (!words[i]) break
			  preview += words[i]+" ";
			}
			if (words.length > 10) preview += ' ... '
			return preview;
		}
		return "";
	}
};

export {
	mapCommonFilters
}
